import { ReactNode } from 'preact/compat';
import { clsx } from 'clsx';
import { CSSProperties } from 'preact/compat';

type SlideProps = {
    className?: string;
    children: ReactNode;
    style?: CSSProperties;
};

export const Slide = ({ className, children, style }: SlideProps) => {
    return (
        <div
            className={clsx(
                'keen-slider__slide w-full h-full px-[30px] py-10 pb-16',
                className,
            )}
            style={style}
        >
            {children}
        </div>
    );
};
